/**
 * Product Class
 */
import {BrandDetails, ProductDetails} from "falcon-api";

export enum ProductDialogType {
  Add,
  Edit
}

export class Product {

  constructor(
    public productId: number,
    public name: string,
    public code: number,
    public isActive: boolean,
    public accountType: string,
    public productType: string,
    public interestRate: number,
    public interestPlanCodes: number[],
    public brandId: number,
    public brandName: string,
    public descriptors: string,
    public infoUrl: string,
    public alloyWorkflowId: number,
    public olbGroupId: number,
    public maxNumberOfAccounts: number,
    public allowJointApplications: boolean,
    public productUID: string,
    public freeDebitCard: boolean,
    public freeStandardCheck: boolean,
    public allowMultiProductApplications: boolean
  ) {

  }

  static init(): Product {
    return new Product(
      0,
      "",
      0,
      false,
      "",
      "",
      0,
      [],
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      true,
      "",
      false,
      false,
      true
    );
  }

  static mapFromDto(productDetails: ProductDetails): Product {
    return new Product(
      productDetails.id!,
      productDetails.name!,
      productDetails.code!,
      productDetails.enabled!,
      productDetails.accountType!,
      productDetails.productType!,
      productDetails.interestRate!,
      productDetails.interestPlanCode!,
      productDetails.brand?.id ?? 0,
      productDetails.brand?.name ?? '',
      productDetails.descriptors!,
      productDetails.infoUrl!,
      productDetails.alloyWorkflowId!,
      productDetails.olbGroupId!,
      productDetails.maxNumberOfAccounts!,
      productDetails.allowJointApplications ?? true,
      productDetails.productUID!,
      productDetails.freeDebitCard!,
      productDetails.freeStandardCheck!,
      productDetails.allowMultiProductApplications ?? true
    );
  }

  mapToDto(): ProductDetails {
    let productDetails = new ProductDetails();

    productDetails.id = this.productId;
    productDetails.name = this.name;
    productDetails.code = this.code;
    productDetails.enabled = this.isActive;
    productDetails.accountType = this.accountType;
    productDetails.productType = this.productType;
    productDetails.interestRate = this.interestRate;
    productDetails.interestPlanCode = this.interestPlanCodes;
    productDetails.descriptors = this.descriptors;
    productDetails.infoUrl = this.infoUrl;
    productDetails.alloyWorkflowId = this.alloyWorkflowId;
    productDetails.olbGroupId = this.olbGroupId;
    productDetails.maxNumberOfAccounts = this.maxNumberOfAccounts;
    productDetails.allowJointApplications = this.allowJointApplications;
    productDetails.productUID = this.productUID;
    productDetails.freeDebitCard = this.freeDebitCard;
    productDetails.freeStandardCheck = this.freeStandardCheck;
    productDetails.allowMultiProductApplications = this.allowMultiProductApplications;

    let brandDetails = new BrandDetails();

    brandDetails.id = this.brandId;

    productDetails.brand = brandDetails;

    return productDetails;
  }
}
